import React, {useEffect, useState} from "react";
import {firestore} from "../../firebase/clientApp";
import {Box, Container, Stack, useTheme} from "@mui/material";
import {Textfit} from "react-textfit";
import {QuestionSwitch} from "./QuestionSwitch";
import pleshDark from "../../theme/pleshDark";
import logoBkt from "../../assets/evento/logo-bkt.png"

function QuestionBar({tipo, domanda, colore}) {
    const theme = useTheme()
    return (
      <Container sx={{height: '40%', marginTop: '3rem', }}>
        <Box sx={{
          position: 'relative',
          width: '100%',
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img
            src={logoBkt}
            alt="bkt-logo"
            style={{width: '35%', height: 'auto', margin: 'auto'}}
          />
          <Textfit mode={'multi'} min={10} max={20}
                   style={{
                     color: tipo === 'color' ? (theme.palette.getContrastText(colore || pleshDark.palette.background.paper)) : theme.palette.text,
                     width: '100%',
                     height: '80%',
                     textAlign: 'center',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     paddingTop: '1.5rem'
                   }}>
            {domanda}
          </Textfit>
        </Box>
      </Container>
    )
}

function QuestionContent({elementPlaying, theme}) {
  return (
    <Container sx={{height: '75%', position: 'relative', paddingTop: '20px', textAlign: 'center'}}>
      <QuestionSwitch elementPlaying={elementPlaying} theme={theme}/>
    </Container>
  )
}

export default function QuestionDialogContent({url, user, idPlaying, open, theme}) {
  const [elementPlaying, setElementPlaying] = useState({})

    useEffect(() => {
        idPlaying && getElementPlaying()
    }, [idPlaying])

    function getElementPlaying() {
        firestore.collection(url+'/queue').doc(idPlaying).onSnapshot(s => {
            setElementPlaying({...s.data(), id: s.id})
            return s.data()
        })
    }
    return(
        <Stack id={'questionDialogBg'} justifyContent={"space-between"} style={{height:'100%', zIndex:1}}>
            <QuestionBar idPlaying={idPlaying} tipo={elementPlaying.tipo} colore={elementPlaying.colore} domanda={elementPlaying.domanda}/>
            <QuestionContent elementPlaying={elementPlaying} user={user} theme={theme}/>
        </Stack>
    )
}
